exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "h1[data-v-203ae855]{font-size:20px}", ""]);
